'use client';
import React from 'react';
import { Box, Typography,  } from '@mui/material';
import {  MuiButton} from '@/components';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

interface SettingsLinksProps {
  handleLogout: () => void;
  handleDeleteAccount: () => void;
  isMobile: boolean;
  palette?: any;
}

const SettingsLinks: React.FC<SettingsLinksProps> = ({
  handleLogout,
  handleDeleteAccount,
  isMobile,
  palette,
}) => {
    const { t } = useTranslation();
  return (
    <Box display={'grid '} mt={'20px'} justifyContent={'center'}>

    <Box display={'flex'}  justifyContent={'center'} gap={'2rem'} >
      <Box>
        <MuiButton
          minWidth={'8.688rem'}
          type='submit'
          variant='contained'
          sx={{
            marginBottom: '1.5rem',
            backgroundColor: '#FFFFFF',
            color: 'black',
            borderRadius: '2rem',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: 'rgb(178, 178, 178)',
              boxShadow: 'none',
            },
            '&:focus': {
              backgroundColor: 'rgb(178, 178, 178)',
              boxShadow: 'none',
            },
            '&:active': {
              backgroundColor: 'rgb(178, 178, 178)',
              boxShadow: 'none',
            },
          }}
          method={() => handleLogout()}>
          <Typography fontSize={'0.8rem'} color={'black'} variant='button'>
            {t('Logout')}
          </Typography>
        </MuiButton>
      </Box>
      <Box>
        <MuiButton
          type='submit'
          minWidth={'8.688rem'}
          variant='contained'
          sx={{
            marginBottom: '1.5rem',
            backgroundColor: '#FFFFFF',
            color: 'black',
            borderRadius: '2rem',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: 'rgb(178, 178, 178)',
              boxShadow: 'none',
            },
            '&:focus': {
              backgroundColor: 'rgb(178, 178, 178)',
              boxShadow: 'none',
            },
            '&:active': {
              backgroundColor: 'rgb(178, 178, 178)',
              boxShadow: 'none',
            },
          }}
          method={() => handleDeleteAccount()}>
          <Typography fontSize={'0.8rem'} color={'black'} variant='button'>
            {t('Delete Account')}
          </Typography>
        </MuiButton>
      </Box>
      </Box>
      <Box  zIndex={100} display={'flex'} gap={isMobile ? '0.7rem ' : '1.5rem'} justifyContent={'center'}>

<Link href='/privacy'>
  <Typography color={'black'} fontSize={'0.8rem'} sx={{cursor:'pointer', textDecoration: 'underline' }}>
    {t('privacy_policy')}
  </Typography>
</Link>
<Link href='/terms'>
  <Typography color={'black'} fontSize={'0.8rem'} sx={{cursor:'pointer', textDecoration: 'underline' }}>
    {t('term_conditions')}
  </Typography>
</Link>
<Link href='mailto:contact@memvy.com'>
  <Typography color={'black'} fontSize={'0.8rem'} sx={{cursor:'pointer',  textDecoration: 'underline' }}>
    {t('contact')}
  </Typography>
</Link>
</Box>
    </Box>
  );
};

export default SettingsLinks;
